import React from "react";
import { render } from "react-dom";
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Header from "./components/Header";
import Home from "./components/Home";
import Contact from "./components/Contact";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Gallery from "./components/Gallery";
import Gallery2 from "./components/Gallery2";
import { useState, useEffect } from "react";

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMob, setIsMob] = useState(false);
  // const handleMenuToggle = (isOpenStatus) => {
  //   setIsMenuOpen(isOpenStatus);
  // };
  useEffect(() => {
    const handleResize = () => {
      console.log(isMenuOpen)
      if (window.innerWidth >= 1015 && isMenuOpen) {
        setIsMenuOpen(false);
      } 
      if (window.innerWidth < 1015) {
        setIsMob(true);
      } else {
        setIsMob(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMenuOpen]); // Only re-syncs when isMenuOpen changes
  return (
    <div className="row">
      <div className={`col-sm-12 col-md-2 mitgar ${isMob?'mob-menu':''}`}>
        <Header isOpen={isMenuOpen} onToggle={setIsMenuOpen}/>
      </div>
      <div style={{ display: isMenuOpen ? 'none' : 'block' }} className={`col-sm-12 col-md-10 tmuna ${isMob ? 'mob' : ''}`}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home isMob={isMob} />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="drawings" element={<Gallery />} />
            <Route path="paintings" element={<Gallery2/>} />
            <Route path="contact" element={<Contact />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}
render(<HomePage />, document.getElementById("root-container"));
